function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

//@ts-nocheck

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import React from 'react';
import { G, Path, Rect, Svg } from 'react-native-svg';
export class ChevronRight extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement(Svg, _extends({}, this.props, {
      viewBox: "0 0 24 24"
    }), /*#__PURE__*/React.createElement(G, {
      "data-name": "Layer 2"
    }, /*#__PURE__*/React.createElement(G, {
      "data-name": "chevron-right"
    }, /*#__PURE__*/React.createElement(Rect, {
      width: "24",
      height: "24",
      transform: "rotate(-90 12 12)",
      opacity: "0"
    }), /*#__PURE__*/React.createElement(Path, {
      d: "M10.5 17a1 1 0 0 1-.71-.29 1 1 0 0 1 0-1.42L13.1 12 9.92 8.69a1 1 0 0 1 0-1.41 1 1 0 0 1 1.42 0l3.86 4a1 1 0 0 1 0 1.4l-4 4a1 1 0 0 1-.7.32z"
    }))));
  }

}